import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-opportunity-lost-types',
  templateUrl: './opportunity-lost-types.component.html',
  styleUrls: ['./opportunity-lost-types.component.scss']
})
export class OpportunityLostTypesComponent {
}
